import { marked } from 'marked';
import { useEffect, useState } from 'react';
import { sanitizeHtml } from '@/lib/sanitizeHtml';

marked.use({ gfm: true, breaks: true });

export function Markdown({ source }: { source?: string | null }) {
  const [html, setHtml] = useState<string>('');
  useEffect(() => {
    if (!source) { setHtml(''); return; }
    // Report .md content comes from client-uploaded ZIPs — sanitize before render.
    Promise.resolve(marked.parse(source)).then((raw) => setHtml(sanitizeHtml(raw)));
  }, [source]);
  if (!source) return <div className="text-sm text-ink-500">Aucun contenu.</div>;
  return <div className="markdown-body" dangerouslySetInnerHTML={{ __html: html }} />;
}
